import { render, staticRenderFns } from "./InspectionReport.vue?vue&type=template&id=67edfab6&scoped=true&"
import script from "./InspectionReport.vue?vue&type=script&lang=js&"
export * from "./InspectionReport.vue?vue&type=script&lang=js&"
import style0 from "./InspectionReport.vue?vue&type=style&index=0&id=67edfab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edfab6",
  null
  
)

export default component.exports